import {FC} from 'react';
//icons
import {ReactComponent as AcceptIcon} from '@icons/accept.svg';
import {ReactComponent as UncheckedIcon} from '@icons/checkbox-unchecked.svg';
import {ReactComponent as CheckedIcon} from '@icons/checkbox-checked.svg';
//mui
import {Box, Typography} from '@mui/material';
//constants
import {BODY1, SUBTITLE2} from '@/utils/constants';
//types
import {IFilterGroup} from '@/utils/types';
//style
import {filterContentStyle} from './FilterContent.styles';

interface IFilterContentProps {
	options: IFilterGroup[];
	onFilterChange: (groupTitle: string, optionTitle: string, id?: number) => void;
}

const FilterContent: FC<IFilterContentProps> = ({options, onFilterChange}) => {
	const selectFilterOption = (groupTitle: string, optionTitle: string, id?: number) =>
		onFilterChange(groupTitle, optionTitle, id);

	return (
		<Box>
			{options.map((group) => (
				<Box key={group.title} sx={filterContentStyle.filterGroup}>
					<Box sx={filterContentStyle.title}>
						<Typography variant={SUBTITLE2}>{group.title}</Typography>
					</Box>

					{group.options.map((option) => (
						<Box
							key={option.title}
							onClick={() =>
								selectFilterOption(group.title, option.value ? option.value : option.title, option?.id ?? undefined)
							}
							sx={{
								...filterContentStyle.option,
								...(option.isCheckBox ? filterContentStyle.checkboxOption : filterContentStyle.selectOption),
							}}
						>
							{option.isCheckBox ? (
								<>
									{option.isSelected ? <CheckedIcon /> : <UncheckedIcon />}
									<Typography variant={BODY1}>{option.title}</Typography>
								</>
							) : (
								<>
									<Typography variant={BODY1}>{option.title}</Typography>
									{option.isSelected && <AcceptIcon />}
								</>
							)}
						</Box>
					))}
				</Box>
			))}
		</Box>
	);
};

export default FilterContent;
